import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'
import { LookupDetailsModelSchema } from './lookup_details_model.ts'

export const LookupHeadersModelSchema = z
  .object({
    id: z.string(),
    category: z.string(),
    is_active: z.boolean(),
    details: z.array(LookupDetailsModelSchema)
  })
  .strict()

const LookupHeadersModelFields = makeFieldKeys(LookupHeadersModelSchema)

export type LookupHeadersModel = z.infer<typeof LookupHeadersModelSchema>

function validateLookupHeadersModel(data: unknown): LookupHeadersModel {
  try {
    return validateWithZodSchema(LookupHeadersModelSchema, data, 'lookup headers model')
  } catch (error) {
    throw new Error(`Lookup headers model validation failed: ${error}`)
  }
}
